<template>
  <li :class="['page-item', {active: active}]">
    <button
      class="page-link"
      :data-page="page"
      role="menuitemradio"
      type="button"
    >
      {{ page }}
    </button>
  </li>
</template>

<script>
export default {
  name: "PaginationButtonDigit",
  props: {
    page: {
      type: Number,
      required: true,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    }
  }
}
</script>
